import { Input } from 'antd';
import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledTextArea = styled(Input.TextArea)`
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;
